import convertImageToDataUrl from '~/helpers/convertImageToDataUrl';
import user1 from '~/assets/img/user-1.png';
import user2 from '~/assets/img/user-2.png';
import user3 from '~/assets/img/user-3.png';
import user4 from '~/assets/img/user-4.png';
import user5 from '~/assets/img/user-5.png';
import user6 from '~/assets/img/user-6.png';
import user7 from '~/assets/img/user-7.png';
import user8 from '~/assets/img/user-8.png';
import user9 from '~/assets/img/user-1.png';

const TEAM_MEMBERS = '@team_members';
const DEFAULT_MEMBERS = [
  {
    firstName: 'Jason',
    lastName: 'Price',
    email: 'janick_parison@yahoo.com',
    gender: 'Male',
    position: 'Admin',
    phone: '+012356789',
    image: user1,
  },
  {
    firstName: 'Jukkoe',
    lastName: 'Sisao',
    email: 'sibyl_kozey@gmail.com',
    gender: 'Male',
    position: 'CEO',
    phone: '+012356789',
    image: user2,
  },
  {
    firstName: 'Harriet',
    lastName: 'King',
    email: 'nadia_block@hotmail.com',
    gender: 'Male',
    position: 'CTO',
    phone: '+012356789',
    image: user3,
  },
  {
    firstName: 'Lenora',
    lastName: 'Benson',
    email: 'feil.wallace@kunde.us',
    gender: 'Male',
    position: 'Lead',
    phone: '+012356789',
    image: user4,
  },
  {
    firstName: 'Olivia',
    lastName: 'Reese',
    email: 'kemmer.hattie@cremin.us',
    gender: 'Male',
    position: 'Strategist',
    phone: '+012356789',
    image: user5,
  },
  {
    firstName: 'Bertha',
    lastName: 'Valdez',
    email: 'loraine.koelpin@tromp.io',
    gender: 'Male',
    position: 'CEO',
    phone: '+012356789',
    image: user6,
  },
  {
    firstName: 'Harriett',
    lastName: 'Payne',
    email: 'nannie_west@estrella.tv',
    gender: 'Male',
    position: 'Digital Marketer',
    phone: '+012356789',
    image: user7,
  },
  {
    firstName: 'George',
    lastName: 'Bryant',
    email: 'delmer.kling@gmail.com',
    gender: 'Male',
    position: 'Social Media',
    phone: '+012356789',
    image: user8,
  },
  {
    firstName: 'Lily',
    lastName: 'French',
    email: 'lucienne.herman@hotmail.com',
    gender: 'Male',
    position: 'Strategist',
    phone: '+012356789',
    image: user9,
  },
];

console.log(DEFAULT_MEMBERS);

const delay = (millis) => new Promise((resolve) => setTimeout(resolve, millis));

export const getAllTeamMembers = async () => {
  await delay(300);

  if (!localStorage.getItem(TEAM_MEMBERS)) {
    localStorage.setItem(TEAM_MEMBERS, JSON.stringify(DEFAULT_MEMBERS));
    return DEFAULT_MEMBERS;
  } else {
    return JSON.parse(localStorage.getItem(TEAM_MEMBERS));
  }
};

export const addNewTeamMember = async ({
  firstName,
  lastName,
  email,
  phone,
  position,
  gender,
  image,
}) => {
  await delay(2000);
  const imageDataUrl = await convertImageToDataUrl(image);

  const newMember = {
    firstName,
    lastName,
    email,
    phone,
    position,
    gender,
    image: imageDataUrl,
  };
  const members = localStorage.getItem(TEAM_MEMBERS)
    ? JSON.parse(localStorage.getItem(TEAM_MEMBERS))
    : [];

  members.push(newMember);

  localStorage.setItem(TEAM_MEMBERS, JSON.stringify(members));

  return newMember;
};

export default {
  getAllTeamMembers,
  addNewTeamMember,
};
